import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { BTaxBill } from 'egov-api';


export const addBTaxBillData = createSourcedAction('Add BTax Bill data', props<{ billsData: BTaxBill[]}>());
